const resources = {
    pageTitle: 'Réinitialiser le mot de passe',
    pageDescription: 'Pour réinitialiser votre mot de passe, veuillez saisir votre adresse de courriel ci-dessous. Nous vous enverrons un courriel contenant un lien qui vous permettra de réinitialiser votre mot de passe.',
    emailPlaceholder: 'Courriel',
    emailRequired: 'Veuillez saisir votre adresse courriel',
    sendResetLinkButton: 'Envoyer un courriel',
    backToSignIn: 'Retour à l’ouverture de session',
    stillHavingTrouble: 'Vous avez toujours des difficultés?',
    unableToResetPassword: 'Si vous ne parvenez pas à réinitialiser votre mot de passe, veuillez appeler le Service à la clientèle au',
    phoneNumber: '(1-877-737-4672)',
    accessibility: 'Accessibilité',
    resetPassword: 'Réinitialiser le mot de passe',
    fallbackErrorMsg: 'Si vous ne parvenez pas à réinitialiser votre mot de passe, veuillez appeler le Service à la clientèle au',
    confirmButton: 'OK',
    forAssistance: '| Surdité et déficience auditive/ATS Voir',
    // Per TD-010: English until SDL delivers translation.
    emailSendFailed: 'We couldn\'t send a reset email. Check your email address or contact customer service.'
};

export default function getResource(label) {
    return resources[label];
}
